import axios from "axios";
import { getAccessToken } from "Helpers/session";
import useSession from "Hooks/session.hook";
import { isEmpty } from "lodash";
import errorHandler from "Utils/error-handler";

const urlPrefix = `${process.env.API_URL}/${process.env.API_VER}`;

const { org } = useSession();

export const fetchOrgGlobalFilterOptions = async (orgID) => {
    const accessToken = getAccessToken();
    try{
        const response = await axios({
            method:'POST',
            url:`${urlPrefix}/org/global/filter/list`,
            data:{
                orgID:orgID,
            },
            headers:{ Authorization:`Bearer ${accessToken}` },
        })

        return response.data.org
    } catch(err:any){
        const { error } = err.response?.data || {}

        if (!isEmpty(error)) {
            const callback = async () => await fetchOrgGlobalFilterOptions()
            const { value, code, message, stack } = await errorHandler.response(
                error,
                { callback }
            )
            return { error: { value, code, message, stack } }
        } else {
            console.log(err.message)
            return { error: { message: err.message } }
        }
    }
}
